import { createContext, useContext, type PropsWithChildren } from 'react';

export type NumberInputSize = 'small' | 'medium' | 'large';

type NumberInputContextValue = {
  size: NumberInputSize;
};

const NumberInputContext = createContext<NumberInputContextValue | null>(null);

type NumberInputContextProviderProps = PropsWithChildren<{
  size: NumberInputSize;
}>;

export const NumberInputContextProvider = ({ size, children }: NumberInputContextProviderProps) => {
  return <NumberInputContext.Provider value={{ size }}>{children}</NumberInputContext.Provider>;
};

export const useNumberInputContext = () => {
  const context = useContext(NumberInputContext);

  if (!context) {
    throw new Error('NumberInput components must be used within NumberInput.');
  }

  return context;
};
